/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import { Col, Container, Row, Breadcrumb, BreadcrumbItem, LinkList, LinkListItem, Spinner } from 'design-react-kit';
import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import ApiService from "../../../services/api";
import { CategoryClass } from '../../categories/models/category';
import Page404 from '../../pages/page404';
import { WidgetClass } from '../../pages/models/widget';
import WidgetSearch from '../../pages/components/widget_search';
import WidgetPageRating from 'pa_kit/apps/page_evaluation/components/widget_page_rating';
import WidgetContacts from 'pa_kit/apps/contacts/components/widget_contacts';
import { ActaAuthContext } from "pa_kit/auth";
import { LocalSettingsContext } from "services/local_settings";
import WidgetPlace from './widget_place';
import parse from 'html-react-parser';
import { Helmet } from "react-helmet-async";


const PagePlacesCategory = () => {

    let { categorySlug } = useParams();

    const settings = useContext(LocalSettingsContext);
    const auth = useContext(ActaAuthContext);

    const localSettings = settings.localSettings;
    const organization = auth.organization;

    const placesParentCategory = localSettings.places_parent_category_data === null ? '' : localSettings.places_parent_category_data.title
    const placesParentCategorySlug = localSettings.places_parent_category_data === null ? '' : localSettings.places_parent_category_data.slug

    const [ categoryList, setCategoryList ] = useState();
    const [ category, setCategory ] = useState();

    const [ mainSection, setMainSection ] = useState({});

    const [ isLoading, setIsLoading ] = useState(true);
    const [ pageNotFound, setPageNotFound ] = useState(false);

    const [ places, setPlaces ] = useState();

    const [ widgetSearch, setWidgetSearch ] = useState();
    const [ widgetPlacesCategory, setWidgetPlacesCategory ] = useState();

    const fetchCategory = async() => {
        try {
            const category = await ApiService.getCategory(categorySlug);
            setCategory(new CategoryClass(category));
            setWidgetSearch(new WidgetClass({
                name: "SearchSection",
                class: "search-allplaces-section",
                type: "search",
                label: "Cerca luoghi",
                search_in: "main_sections",
                search_id: 8
            }));
            setWidgetPlacesCategory(new WidgetClass({
                name: "PlacesCategory",
                class: "places-category",
                type: "place",
                category: category.id,
                label: <span></span>
            }));
            setIsLoading(false);              
        } catch (error) {
            setPageNotFound(true);            
        }       
    }    

    const fetchCategoryList = async() => {
        let categoryArray = [];
        const categoryListData = await ApiService.getCategoryList();
        const categoryList = categoryListData.filter(category => category.is_place === true);
        Promise.all(categoryList.map((category) => ApiService.getLatestPlacesByCategory(category.id))).then((places) => {
            places.forEach((place) => {
                if(place.length > 0) {
                    categoryArray.push(place[0].category.id);
                }
            });
            const categoryPlaces = categoryList.filter(cat => categoryArray.includes(cat.id));
            setCategoryList(categoryPlaces);
        });
    }

    const fetchMainSections = async() => {
        const mainSectionsData = await ApiService.getMainSections();
        const mainSection = mainSectionsData.filter(main_section => main_section.id === 8); // Luoghi
        setMainSection(mainSection[0]);
    }

    const fetchPlaces = async() => {
        if(category) {
            const placesData = await ApiService.getLatestPlacesByCategory(category.id);
            setPlaces(placesData);
        }            
    }

    useEffect(() => {
        fetchCategory();
        fetchCategoryList();
        fetchMainSections();  
        fetchPlaces(); 
    }, [isLoading]);
       
    if(pageNotFound) return <Page404 />;
    if(isLoading) return <Container style={{ padding: "50px" }}><Spinner active /></Container>; 
    return <>
        <Helmet>
            <title>{category.name + ' | ' + organization.name}</title>
            <meta name="description" content={category.description.replace(/(<([^>]+)>)/gi, "")} />
        </Helmet>
        <Container fluid className="p-0 places-category-main-wrapper">
            <Container className="pt-5 px-3">
                <Row>
                    <Col>
                        <Breadcrumb>
                            <BreadcrumbItem>
                                <a href='/'>Home</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            {placesParentCategory !== ''
                                && 
                                <BreadcrumbItem>
                                    <a href={'/' + placesParentCategorySlug + '/'}>{placesParentCategory}</a>
                                    <span className='separator'>/</span>
                                </BreadcrumbItem>
                            }
                            <BreadcrumbItem>
                                <a href='/luoghi/'>{mainSection.name}</a>
                                <span className='separator'>/</span>
                            </BreadcrumbItem>
                            <BreadcrumbItem>
                                {category.name}
                            </BreadcrumbItem>
                        </Breadcrumb>
                    </Col>
                </Row>
            </Container>

            <Container className={'page-title places-category-page-title-page'}>
                <Row>
                    <Col lg="7">
                        <h1>{category.name}</h1>
                        <div className="mt-4">{parse(category.description)}</div>
                        <WidgetSearch widget={widgetSearch} />
                    </Col>
                    <Col lg="5">
                    <Container fluid className={'places-page-menu page-menu-content ms-lg-5 ps-lg-5'}>
                        <p className="menu-name mb-2">{mainSection.name}</p>
                        <LinkList>
                            {categoryList && categoryList.map((category) => 
                                category.alt_link 
                                    ? <LinkListItem key={"key_menuItem_" + category.name} href={category.alt_link}  target="_blank" rel="noreferrer" className="ps-0 menu-item-link">{category.name}</LinkListItem>
                                    : <LinkListItem key={"key_menuItem_" + category.name} href={'/luoghi/' + category.slug + '/'} className="ps-0 menu-item-link">{category.name}</LinkListItem>                                
                            )}
                        </LinkList>
                    </Container>
                    </Col>
                </Row>
            </Container>
            
            {places && places.length !== 0 &&
                <Container className="mt-5">
                    <h2>Elenco luoghi</h2>
                    <Row>
                        <WidgetPlace widget={widgetPlacesCategory} />
                    </Row>
                </Container>
            }   

            <Container fluid className={'rating-wrapper page-rating places-category-page-rating'}>
                <WidgetPageRating page_title={category.name} />
            </Container>

            <Container fluid className={'contacts-wrapper places-category-page-contacts'}>
                <WidgetContacts />
            </Container>  

        </Container>
        </>;
}

export default PagePlacesCategory;